import React from 'react';
import { useAppSelector } from 'hooks/useAppSelector';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { saveFirstPassword } from 'store/slices/user';
import { useHistory } from 'react-router-dom';

import { Link, Typography } from '@mui/material';
import ErrorMessage from '../ErrorMessage';
import { AuthDialog } from '../AuthDialog/AuthDialog';
import { logout } from '../../store/slices/auth';
import SetFirstPasswordForm from '../SetFirstPasswordForm';

const FinishRegistration = () => {
    const dispatch = useAppDispatch();

    const history = useHistory();
    const user = useAppSelector((state) => state.user);
    const auth = useAppSelector((state) => state.auth);
    const { savingPassword, savingPasswordError, savingPasswordErrorCont, savingPasswordSuccess } = user;
    const { tokenData } = auth;
    const isComplete = tokenData?.data?.isComplete;
    const { pathBeforeLoginRequest } = useAppSelector((state) => state.sessionStatus);

    return (
        <AuthDialog
            title={'Finish your account'}
            processing={savingPassword}
            error={savingPasswordError}
            success={savingPasswordSuccess}
            errorContent={
                <ErrorMessage
                    specificError={savingPasswordErrorCont ?? 'Oops! We encountered an issue while trying to save your password.'}
                />
            }
            successContent={
                <>
                    <Typography variant={'subtitle1'}>Awesome! Your password's all set! 🥳</Typography>
                    <Typography variant={'body1'}>
            Go ahead and &nbsp;
                        <Link href="/edit-profile" underline="hover">
              jump into your account
                        </Link>
            . And hey, don't forget to fill out your profile a bit more – it'll help other pilots find you more easily!
                    </Typography>
                </>
            }
            isModal={!(isComplete || savingPasswordError)}
            onClose={() => {
                if (savingPasswordError) {
                    dispatch(logout());
                    history.push('/');
                } else {
                    history.push(pathBeforeLoginRequest ?? '/');
                }
            }}
        >
            <SetFirstPasswordForm
                onSubmit={(password) => void dispatch(saveFirstPassword({ password }))}
                isProcessing={savingPassword}
                errorMessage={savingPasswordErrorCont}
            />
        </AuthDialog>
    );
};

export default FinishRegistration;
